import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as ContainerActivityActions from '../_actions/containerActivity';
import { ContainerActivity } from '../_models';

export interface ContainerActivityState extends EntityState<ContainerActivity> {
  loading: boolean;
  loaded: boolean;
  error: any;
}

export const adapter: EntityAdapter<ContainerActivity> = createEntityAdapter<ContainerActivity>();

const initialState: ContainerActivityState = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});

const containerActivityReducer = createReducer(
  initialState,

  on(ContainerActivityActions.loadContainerActivities, (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
  })),

  on(ContainerActivityActions.loadContainerActivitiesSuccess, (state, { containerActivities }) =>
    adapter.setAll(containerActivities, { ...state, loaded: true, loading: false })
  ),

  on(ContainerActivityActions.loadContainerActivitiesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error,
  })),

  on(ContainerActivityActions.addContainerActivitySuccess, (state, { containerActivity }) =>
    adapter.addOne(containerActivity, state)
  ),

  on(ContainerActivityActions.updateContainerActivitySuccess, (state, { containerActivity }) =>
    adapter.upsertOne(containerActivity, state)
  ),

  on(ContainerActivityActions.deleteContainerActivitySuccess, (state, { id }) =>
    adapter.removeOne(id, state)
  ),

  on(
    ContainerActivityActions.addContainerActivityFailure,
    ContainerActivityActions.updateContainerActivityFailure,
    ContainerActivityActions.deleteContainerActivityFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: ContainerActivityState | undefined, action: Action) {
  return containerActivityReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
